import React from "react";
import {Svg, G, Path} from "react-native-svg";
import {ICustomSvgProps} from "./AngryIcon";

const WalletIcon: React.FC<ICustomSvgProps> = (props) => {
    return (
        <Svg width={props.width} height={props.height} fill="none" viewBox="0 0 392 377" {...props}>
            <G transform="matrix(1,0,0,1.22139,-41.6238,-102.73)">
                <Path
                    d="M433.492,165.189L433.492,310.974C433.492,355.724 389.119,392.054 334.462,392.054L140.654,392.054C85.998,392.054 41.624,355.724 41.624,310.974L41.624,165.189C41.624,120.44 85.998,84.109 140.654,84.109L334.462,84.109C389.119,84.109 433.492,120.44 433.492,165.189ZM413.492,165.189C413.492,129.478 378.08,100.484 334.462,100.484L140.654,100.484C97.036,100.484 61.624,129.478 61.624,165.189L61.624,310.974C61.624,346.686 97.036,375.68 140.654,375.68L334.462,375.68C378.08,375.68 413.492,346.686 413.492,310.974L413.492,165.189Z"
                    fill={props.color || "#71706F"}
                />
            </G>
            <G transform="matrix(1,0,0,0.592691,0,78.1576)">
                <Path
                    d="M391.467,97.13L391.467,273.728C391.467,283.046 386.99,290.6 381.467,290.6L208.196,290.6C202.673,290.6 198.196,283.046 198.196,273.728L198.196,97.13C198.196,87.812 202.673,80.258 208.196,80.258L381.467,80.258C386.99,80.258 391.467,87.812 391.467,97.13ZM371.467,114.003C371.467,114.003 218.196,114.003 218.196,114.003L218.196,256.856C218.196,256.856 371.467,256.856 371.467,256.856L371.467,114.003Z"
                    fill={props.color || "#71706F"}
                />
            </G>
            <G transform="matrix(1,0,0,1,0,-10.1069)">
                <Path
                    d="M257.286,178.06C268.383,178.06 277.393,187.069 277.393,198.167C277.393,209.264 268.383,218.274 257.286,218.274C246.189,218.274 237.179,209.264 237.179,198.167C237.179,187.069 246.189,178.06 257.286,178.06ZM257.286,198.06C257.227,198.06 257.179,198.108 257.179,198.167C257.179,198.226 257.227,198.274 257.286,198.274C257.345,198.274 257.393,198.226 257.393,198.167C257.393,198.108 257.345,198.06 257.286,198.06Z"
                    fill={props.color || "#71706F"}
                />
            </G>

        </Svg>
    );
};

export default WalletIcon;
